<template>
    <div>
        <el-form :model="show_form" label-width="120px" class="event-form">

            <!-- 任务标题 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="任务标题:">
                        <span>{{ show_form.title }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 应用名称 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="应用名称:">
                        <span>{{ show_form.app_tree.name }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 步骤条 -->
            <el-divider></el-divider>

            <!-- 应用类型 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="应用类型:">
                        <span>{{ show_form.app_tree.apptype }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- Git 地址 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="Git 地址:">
                        <span>{{ show_form.app_tree.git_path }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 负责人 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="负责人:">
                        <span v-for='(item, index) of show_form.app_tree.superviser' :key='index'>{{ item }}&nbsp;</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 级别 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="级别:">
                        <span>{{ show_form.app_tree.rank }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- Param -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="Param:">

                        <el-table :data="show_form.app_tree.params" border stripe style="width: 500px">

                            <el-table-column label="ID" type="index" ></el-table-column>

                            <el-table-column label="参数名" prop="key"></el-table-column>

                            <el-table-column label="参数值" prop="value"></el-table-column>

                        </el-table>

                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 开发人员 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="开发人员:">
                        <span v-for='(item, index) of show_form.app_tree.devuser' :key='index'>{{ item.name }}&nbsp;</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 测试人员 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="测试人员:">
                        <span v-for='(item, index) of show_form.app_tree.qauser' :key='index'>{{ item.name }}&nbsp;</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 产品经理 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="产品经理:">
                        <span v-for='(item, index) of show_form.app_tree.pmuser' :key='index'>{{ item.name }}&nbsp;</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 邮件组 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="邮件组:">
                        <span v-for='(item, index) of show_form.app_tree.mail' :key='index'>{{ item.mail }}&nbsp;</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 步骤条 -->
            <el-divider></el-divider>

            <!-- 主机 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="主机:">
                        <span v-for='(item, index) of show_form.server_list' :key='index'>{{ item }}&nbsp;</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 附件 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="附件:">
                        <a v-for='(item, index) of show_form.annex' :key='index' :href="item.url" rel="external nofollow" download="模板">
                            <el-button type="text">{{item.name}}</el-button>
                        </a>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 备注 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注:">
                        <span>{{ show_form.describe }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 应用名称 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <!-- <el-button v-if='show_form.can_deploy' type="primary">部署</el-button> -->
                        <el-button
                        v-if='deployLogData.end && deployLogData.next_one'
                        type="primary"
                        @click='deployNext'>部署下一台</el-button>
                        <!-- <el-button  v-if='!show_form.can_deploy && (!deployLogData.end || deployLogData.next_one)' type="danger">终止</el-button> -->
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <!-- 步骤条 -->
        <el-steps :active="+deployLogData.setups"  align-center>

            <el-step
                v-for="(item, index) of setups"
                :key='index'
                :title="'步骤 ' + (index + 1)"
                :description='item'>
            </el-step>

        </el-steps>

        <!-- 日志 -->
        <div class='logList'>

            <li v-for='(item, index) of list' :key='index'>

                <strong>{{item['@timestamp']}}</strong>

                &nbsp;&nbsp;

                <span
                    :style='{ "color": item.color, "background": item.color === "black" ? "#fff" : "#e5e5e5" }'
                    v-if='!Array.isArray(item.message)'>

                    {{item.message}}

                </span>

                <span
                    :style='{ "color": item.color, "background": item.color === "black" ? "#fff" : "#e5e5e5" }'
                    v-if='Array.isArray(item.message)'>

                    <span v-if='item.message[0]'>{{item.message[0]}}</span>

                    <a
                        v-if='item.message[1]'
                        :href="item.message[1]"
                        class="document-btn"
                        target="_blank">
                        {{item.message[1]}}
                    </a>

                    <span v-if='item.message[2]'>{{item.message[2]}}</span>
                </span>

            </li>

            <el-tag v-if='!deployLogData.end' v-loading="true" element-loading-spinner="el-icon-loading"></el-tag>
        </div>

    </div>
</template>

<script>
    import services from './cicd.services'
    import { clearTimeout, setTimeout } from 'timers'
    export default {

        data() {
            return {
                show_form: {
                    app_tree: {}
                },
                deployLogData: {},
                list: [],
                timer: null,
                setups: ['输入检查', '环境检查', '代码检查', '生成tag', '打包代码', '部署']
            }
        },

        mounted() {
            this.getlist()
        },

        methods: {
            // 获取日志信息
            getlist(params) {
                params = {
                    ...params,
                    deploy_id: this.$route.query.ind
                }
                services.deployLog(params)
                    .then(res => {
                        this.deployLogData ={ ...res }

                        res.line.forEach(item => this.list.push(item))

                        clearTimeout(this.timer)

                        if (res.end) return false

                        if (this.deployLogData.stop_time) {
                            this.timer = setTimeout(() => {
                                this.getlist({ start_time: res.stop_time })
                                this.chatlog()
                            }, 2000)
                        }

                    })
                    .catch(err => this.$message.error(err.message))
            },

            chatlog() {
                this.$nextTick(() => {
                    this.$el.scrollTop = this.$el.scrollHeight;
                })
            },

            // 部署下一台
            deployNext() {
                let params = {
                    deploy_id: this.$route.query.ind,
                    next_one: true,
                    user_name: localStorage.getItem('internalUserid'),
                }
                services.deployRun(params)
                    .then(res => this.getlist())
                    .catch(err => this.$message.error(err.massage))
            },

            // 获取部署单详情
            getDetil() {
                services.deployDescribe({ deploy_id: this.$route.query.ind })
                    .then(
                        res => {
                            let params = []
                            for (let item in res.app_tree.params) {
                                params.push({ key: item, value: res.app_tree.params[item] });
                            }
                            this.show_form = res && {
                                ...res,
                                app_tree: {
                                    ...res.app_tree,
                                    params
                                }
                            }
                        })
                    .catch(err => err && this.$message.error(err.message))
            }
        },

        destroyed() {
            clearTimeout(this.timer)
        }
    }
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        width: 20px;
        height: 8px;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 12px;
        border: 6px solid rgba(0, 0, 0, 0);
        box-shadow: 8px 0 0 #A5ADB7 inset;
    }

    ::-webkit-scrollbar-thumb:hover {
        box-shadow: 8px 0 0 #4A4A4A inset;
    }
    .el-tag {
        border: none;
        margin-top: 10px;
        /deep/ .el-icon-loading{
            font-size: 30px;
            color: #000;
        }
    }
    .document-btn {
        border-bottom: 1px solid #ccc;
    }
    .event-form {
        margin-top: 40px;
    }
</style>
